import React from 'react';
import { EventPanelFormType, RadioChannelOption } from '@mark43/cad-api';
import { globalAttributes } from '../../../../../common/global-attributes';
import { FormSelect } from '../../../../../forms/integrated-form-controls/form-select';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { useFormContext } from 'react-hook-form';

export function RadioChannelsSection(props: {
    agencyTypeGlobalAttrId: number;
    childAdditionalRadioChannels: RadioChannelOption[];
    radioChannelOptions: RadioChannelOption[];
}): React.ReactElement {
    const eventForm = useFormContext<EventPanelFormType>();

    const primaryRadioChannelFieldName =
        props.agencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.FIRE
            ? 'firePrimaryRadioChannel'
            : props.agencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.POLICE
            ? 'policePrimaryRadioChannel'
            : 'emsPrimaryRadioChannel';

    const childAdditionalRadioChannels = props.childAdditionalRadioChannels;

    return (
        <TabSection title="Radio Channels">
            <FormSelect
                control={eventForm.control}
                label="Primary"
                name={primaryRadioChannelFieldName}
                options={props.radioChannelOptions}
                isMultiple={false}
                asEditable={true}
                length="md"
                eventNotificationName="RADIO_CHANNEL"
            />
            <FormSelect
                control={eventForm.control}
                label="Additional"
                name="additionalRadioChannels"
                options={props.radioChannelOptions}
                isMultiple={true}
                asEditable={true}
                truncateSelectedCount={2}
                length="md"
                eventNotificationName="ADDITIONAL_RADIO_CHANNEL"
            />
            {!!childAdditionalRadioChannels.length && (
                <FormSelect
                    control={eventForm.control}
                    label="Additional Merged"
                    name="childAdditionalRadioChannels"
                    options={props.childAdditionalRadioChannels}
                    isMultiple={true}
                    asEditable={true}
                    truncateSelectedCount={2}
                    length="md"
                />
            )}
        </TabSection>
    );
}
